/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-13 12:39:21
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-06 12:23:13
 * @FilePath: /unifyxp-v2-store-portal/src/layout/SalesChannelsVersionLayout/SalesChannelsVersionLayout.tsx
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */

import React from 'react';

import { menuArray } from '@/src/config/SiderConfig/SalesChannelVersionSiderConfig';
import T from 'src/layout/Components/PageStructure/PageStructure';
import { useSalesChannel } from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import {
  useFetchSalesChannel,
  //useClearSalesChannel,
} from 'src/constrains/SalesChannelHOC/useSalesChannel';
import {
  // useQueryLanguageListContentEditor,
  // // EnumAction,

  EnumMultiLanguageType,
} from 'src/constrains/SalesChannelMultiLanguageSelect';

const SalesChannelVersionLayout = (props) => {
  useFetchSalesChannel({ forceUpdate: true });
  useSalesChannel({
    type: EnumMultiLanguageType.SalesChannelSettingsCheckout,
    saleChannelUuidKey: 'uuid',
    isStyleRequired: false,
    noListener: true,
  });
  React.useEffect(() => {
    return () => {
      //useClearSalesChannel();
    };
  }, []);

  return <T menuArray={menuArray}>{props.children}</T>;
};
export default SalesChannelVersionLayout;
